<div class="section">
    <div class="container">


        <div class="row">
            <div class="col-md-4 col-sm-6 ml-auto mr-auto">
                <div class="card card-register">
                    <h3 class="card-title">Doctor Portal Login</h3>
                    <form class="register-form">
                        <label>Practice Number</label>
                        <input [(ngModel)]="search_practice_number" name="search_practice_number" type="text"
                            class="form-control" placeholder="" value="" [ngModelOptions]="{standalone: true}">


                        <button class="btn btn-danger btn-block btn-round" (click)="open(Login,'')">Search</button>



                        <label class="text-danger">{{
                            result_message }}</label>
                    </form>

                </div>
            </div>

            <div class="col-md-6 col-sm-6 ml-auto mr-auto">
                <h4 class="title">
                    <small>Downloads</small>
                </h4>
                <div class="table-responsive mt-2">
                    <table class="table">

                        <tbody>
                            <tr class="w-100" *ngFor="let row of Data">

                                <td class="w-75">{{row.name}}</td>
                                <td> <a class="btn btn-sm btn-success"
                                        (click)="downloadFile(row._id, row.filename, row.mimetype, row.filepath)"><i
                                            class="nc-icon nc-cloud-download-93"></i>
                                        Download</a></td>


                            </tr>

                            <tr class="w-100">

                                <td class="w-75">Lotus Notes Traveler</td>
                                <td> <a class="btn btn-sm btn-info" href="https://mail1.e-md.co.za/servlet/traveler"
                                        target="_blank"> <i class="nc-icon nc-app"></i> Install </a></td>


                            </tr>


                        </tbody>
                    </table>
                </div>
                <!-- <h4 class="title">
                    <small>Installs</small>
                </h4>
                <div class="modal-footer b-0">
                    <div class="left-side content-align-start">
                        Lotus Notes Traveler
                    </div>
                    <div class="divider"></div>
                    <div class="right-side">

                        <a class="btn btn-info" href="https://e-md.co.za/EMdPortal/LotusNotesRedirect"> Install </a>
                    </div>
                </div> -->
                <p class="mt-2">

                    Contact us on <strong> 0860 018 363 </strong> for any support enquiry.

                </p>
            </div>



            <ng-template #Login size="lg" let-c="close" let-d="dismiss">
                <div class="modal-header mogal-lg no-border-header text-center">
                    <button type="button" class="close" (click)="d('Cross click')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h6 class="text-muted">User Details</h6>
                    <h3 class="modal-title text-center">Doctor Portal Login</h3>
                    <p>Log in to your account</p>
                </div>
                <div class="modal-body">
                    <div class="row bg-light mt-1">
                        <div class="col col-sm-4 ">
                            Username
                        </div>
                        <div class="col col-sm-8">

                            <select class="dropdown w-100" [(ngModel)]="selected_username_id" id="selected_username_id"
                                (ngModelChange)="get_user_databases_on_change($event)">

                                <option *ngFor="let user_item of processed_data" [value]="user_item._id"> {{
                                    user_item.username }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="row bg-light mt-1">
                        <div class="col col-sm-4 ">
                            Database
                        </div>
                        <div class="col col-sm-8">

                            <select class="dropdown w-100" [(ngModel)]="selected_database" id="selected_database">

                                <option *ngFor="let database_item of selected_user_object.databases"
                                    [value]="database_item.database"> {{
                                    database_item.database_name }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="row bg-light mt-1 ">
                        <div class="col col-sm-4">
                            Email
                        </div>
                        <div class="col col-sm-8">
                            {{selected_user_object.dremail}}
                        </div>
                    </div>
                    <div class="row mt-1">
                        <div class="col col-sm-4">
                            Mobile
                        </div>
                        <div class="col col-sm-8">
                            {{selected_user_object.drcell}}
                        </div>
                    </div>
                    <div class="row mt-1">
                        <div class="col col-sm-4">

                        </div>
                        <div class="col col-sm-8">
                            <a *ngIf="this.selected_database != ''" (click)="reset_password($event)"
                                class="btn btn-link">
                                RESET PASSWORD
                            </a>
                            <a *ngIf="this.selected_database == ''" disabled>
                                RESET PASSWORD
                            </a>
                        </div>

                    </div>


                    <div *ngIf="this.reset_password_flag == true" class="row mt-1">
                        <div class="col col-sm-3">
                            Send via
                        </div>
                        <div class="col col-sm-5">
                            <select class="dropdown w-100" [(ngModel)]="selected_reset_method"
                                id="selected_reset_method">

                                <option value="email">
                                    Email</option>
                                <option value="sms">SMS</option>
                                <option value="support">
                                    Support</option>

                            </select>
                        </div>
                        <div class="col col-sm-4">

                            <a class="btn btn-success btn-sm" (click)="reset_password_submit($event)">
                                Send OTP!
                            </a>
                        </div>

                    </div>

                    <div *ngIf="this.loading == true" class="row mt-1">
                        <div class="loader">

                        </div>
                    </div>


                </div>

                <div class="modal-footer">
                    <div class="left-side">
                        <button type="button" class="btn btn-danger" (click)="c('Close click')">Never mind</button>
                    </div>
                    <div class="divider"></div>
                    <div class="right-side">
                        <button *ngIf="this.selected_database != ''" type="button" class="btn btn-success"
                            (click)="c('Continue')">Continue</button>
                        <button *ngIf="this.selected_database == ''" type="button" disabled class="btn btn-light"
                            (click)="c('Continue')">Continue</button>
                    </div>
                </div>
            </ng-template>


         

        </div>

    </div>
</div>